import { get } from "lodash";
import { createSelector } from "reselect";
import {
  operationEnabled,
  operationPermitted,
  operationAvailable
} from "../../../utils/operations.js";

// -- QUERIES -- //

const permissionsQuery = state => get(state, "account.permissions", {});

// -- PROPS QUERIES -- //

const operationsQuery = (state, props) => get(props, "data.operations", null);
const enabledOperationsQuery = (state, props) =>
  get(props, "data.enabledOperations", null);

// -- SELECTORS -- //

export const selectOperationEnabled = createSelector(
  [enabledOperationsQuery],
  enabledOperations => operationName => {
    if (enabledOperations) {
      return operationEnabled(operationName, enabledOperations);
    }

    return false;
  }
);

export const selectOperationPermitted = createSelector(
  [operationsQuery, permissionsQuery],
  (operations, permissions) => operationName => {
    if (operations) {
      return operationPermitted(operationName, operations, permissions);
    }

    return false;
  }
);

export const selectOperationAvailability = createSelector(
  [
    operationsQuery,
    enabledOperationsQuery,
    permissionsQuery,
    (state, props, operationName) => operationName
  ],
  (operations, enabledOperations, permissions, operationName) => {
    return operationAvailable(
      operationName,
      operations,
      enabledOperations,
      permissions
    );
  },
  {
    memoizeOptions: {
      maxSize: 10
    }
  }
);

// mutates the passed entiity object, adding an availability object to all operation objects
export function stampOperationPermissions(entity, permissions) {
  Object.keys(entity).forEach(value => {
    const item = entity[value];

    if (value === "operations" && item !== null) {
      item.forEach((operation, index) => {
        const availability = operationAvailable(
          operation.name,
          entity.operations,
          entity.enabledOperations,
          permissions
        );
        entity[value][index].availability = availability;
      });
    } else if (typeof item === "object" && item !== null) {
      stampOperationPermissions(item, permissions);
    }
  });

  return entity;
}

// using the following export pattern so we can mock more easily using jest
const operationSelector = {
  permissionsQuery,
  stampOperationPermissions,
  selectOperationEnabled,
  selectOperationPermitted,
  selectOperationAvailability
};

export default operationSelector;
